import React from 'react'
import LazyImg from 'javascripts/common/LazyImg'
import styles from './ModalError.module.scss'
import ChangeModal from './changeModal'
import Icon from '../../../../../assets/images/identify/icon_error.svg'
import ModalButton from 'spa/member/components/ModalButton'

interface ErrorModalProps extends ChangeModal{
  error: string
}

const ModalError: React.FC<ErrorModalProps> = (props) => {
  return (
    <>
      <div className={`${styles.overlay} js-modal-overlay`}>
        <div className={`${styles.modalContainer} js-modal-container`}>
          <div className={styles.identificationIcon}><LazyImg src={Icon} /></div>
          <div className={styles.sectionTitle}><p>通信<span>エラー</span>が発生しました</p></div>
          <div className={styles.sectionText}>
            <p>大変申し訳ありませんが、時間を空けて再度申請を行なって頂きます様、よろしくお願いいたします。</p>
          </div>
          <div className={styles.sectionBtn}>
            <ModalButton buttonType='BACK' onClick={() => props.changeModal('')}>閉じる</ModalButton>
          </div>
        </div>
      </div>
    </>
  )
}
export default ModalError
